import React, { useContext, useEffect } from 'react';

import moment from 'moment';

import MonthsTabNav from 'components/MonthsTabNav/MonthsTabNav';
import { SubscriptionsContext } from 'Insights/Subscriptions/SubscriptionsContext';

const MonthsNav = () => {
  const { selectedRange, onChangeRange, setSelectedMonth, selectedMonth, getSubscriptions } =
    useContext(SubscriptionsContext);

  const onSelectMonth = (month) => {
    setSelectedMonth(moment(month).format('YYYY-MM'));
  };

  const isDisabledMin = () => {
    let res = true;
    if (selectedRange.months.length) {
      res = moment(selectedRange.start).clone().isSameOrBefore(selectedRange.rangeMin, 'month');
    }
    return res;
  };

  const isDisabledMax = () => {
    let res = true;
    if (selectedRange.months.length) {
      res = moment(selectedRange.start).clone().add(8, 'months').isSameOrAfter(selectedRange.rangeMax, 'month');
    }
    return res;
  };
  useEffect(() => {
    const start = moment(selectedRange.start).format('YYYY-MM');
    const end = moment(selectedRange.start).clone().add(10, 'months').format('YYYY-MM');
    getSubscriptions(start, end);
  }, [selectedRange.start]);

  return (
    <MonthsTabNav
      months={selectedRange.months.map((item) => ({
        ...item,
        id: item.month,
        isActive: moment(selectedMonth).isSame([item.year, item.month - 1], 'month'),
        dateMoment: moment([item.year, item.month - 1]),
      }))}
      isLoading={selectedRange.loading || selectedRange.months.length === 0}
      onSelectMonth={onSelectMonth}
      isPrevDisabled={isDisabledMin()}
      isNextDisabled={isDisabledMax()}
      onNext={() => onChangeRange('next')}
      onPrev={() => onChangeRange('prev')}
    />
  );
};

export default MonthsNav;
